/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

import '../assets/css/style.css'
import titleTumitate from '../assets/img/title/title_tumitate.svg'
import image1 from '../assets/img/tumitate/image_1.svg'
import image2 from '../assets/img/tumitate/image_2.svg'
import image3 from '../assets/img/tumitate/image_3.svg'
import attention from '../assets/img/tumitate/attention.svg'
import { Link } from 'react-router-dom'
import { Header } from '../components/header'
import { Footer } from '../components/footer'
import { useHeadTitle } from '../hook/useHeadTitle'
import { useDealerCodeUrl } from '../hook/useDealerCode'
import { useDescription } from '../hook/useDescription'

export default function Tsumitate() {
  useHeadTitle('今こそ資産運用を考えよう', 'つみたて投資とは')
  useDescription(
    '資産運用について知っておきたい基本とコツ。野村アセットマネジメントが資産運用に取り組む皆さまをサポートします。'
  )
  return (
    <React.Fragment>
      <Header />
      <main>
        <section>
          <div className="c-title-wrap">
            <h2 className="c-title--primary">
              <span className="c-title__balloon">
                <span>コツコツ買って長く続けよう</span>
              </span>
              <img src={titleTumitate} alt="つみたて投資とは" />
            </h2>
            <p className="c-title__lead">
              つみたて投資とは、毎月など決まったタイミングで、決まった額をコツコツ投資する方法です。
              <br />
              少額から始められ、投資タイミングをはかる必要がないため、無理なく続けられます。
            </p>
          </div>
          <div className="l-container">
            <div className="u-pt27px">
              <section className="c-box">
                <h3 className="c-box__head">
                  <span className="c-box__head__title">
                    資産づくりのポイントは「早く始めて、長く続ける」
                  </span>
                </h3>
                <div className="p-tumitate__box-body">
                  <p className="p-tumitate__lead">
                    {/* eslint-disable-next-line max-len */}
                    資産づくりのポイントは、少しでも早く始めることです。早く始めることで運用期間が長くなり、資産をより大きく増やすことが期待できます。下記の試算では、今すぐにつみたて投資を始めた場合、15年後から2倍の金額をつみたてるよりも、資産が大きく増える結果となりました。
                  </p>
                  <p className="u-text--center u-mt57px">
                    <img
                      src={image1}
                      alt="年率３％で毎月つみたて投資をした場合のスタート時期による比較"
                    />
                  </p>
                  <p className="c-note u-mt20px">
                    {/* eslint-disable-next-line max-len */}
                    ・上記は運用期間の違いによる資産形成のイメージをつかんでいただくための試算であり、ファンドの運用実績ではありません。局面によっては(例えば、価格が長期にわたって下降トレンドをたどるなど)、投資成果が期待できない場合があります。
                  </p>
                  <p className="c-note">
                    ・計算過程において税金・手数料等は考慮しておりません。また、預金は金利等は考慮しておりません。
                    <br />
                    (作成)野村アセットマネジメント
                  </p>
                  <p className="c-note u-mt20px">
                    ※上記は、つみたて投資の一例であり、全てを網羅しているわけではありません。また、シミュレーションであり、将来の投資成果を示唆あるいは保証するものではありません。
                  </p>
                </div>
              </section>
            </div>

            <div className="u-pt80px">
              <section className="c-box">
                <h3 className="c-box__head">
                  <span className="c-box__head__title">
                    コツコツ買って、量を増やす「つみたて投資」
                  </span>
                </h3>
                <div className="p-tumitate__box-body">
                  <p className="p-tumitate__lead">
                    「つみたて投資」は投資初心者でも始めやすい方法と言われます。
                    <br />
                    例えば投資を考える時に、購入する資産の「価格」を重視しすぎると、いつ、いくらで購入したら良いか決められなくなりがちです。
                    毎月一定の金額で投資信託を購入する「つみたて投資」ならば、価格が高いときは購入する量が少なく、価格が安いときは購入する量が多くなります。
                    <br />
                    ここでは「4,000円を元手に、りんごがいくつ買えるか」という例で比べてみましょう。
                  </p>
                  <p className="u-text--center u-mt57px">
                    <img src={image2} alt="「4,000円を元手に、りんごがいくつ買えるか」という例" />
                  </p>
                  <p className="p-tumitate__lead">
                    このケースでは購入する元手は同じですが、購入した量は「つみたて投資」の方が多くなりました。
                    <br />
                    価格を意識しすぎずに、コツコツと買い付けて量を増やしておくことが大切です。
                  </p>
                  <p className="c-note u-mt20px">
                    （作成）野村アセットマネジメント
                    <br />
                    {/* eslint-disable-next-line max-len */}
                    ※上記は定額購入の一例であり、実際の値動き等を示すものではありません。個数の計算では小数第2位を切り上げ、平均購入単価の計算では小数第2位を四捨五入して算出しています。また、計算過程において税金・手数料等は考慮しておりません。実際の算出とは異なります。
                  </p>
                </div>
              </section>
            </div>

            <div className="u-pt80px">
              <section className="c-box">
                <h3 className="c-box__head">
                  <span className="c-box__head__title">価格が下がると、量がたくさん買える</span>
                </h3>
                <div className="p-tumitate__box-body">
                  <p className="p-tumitate__lead">
                    {/* eslint-disable-next-line max-len */}
                    一括投資の場合、価格が投資開始時の水準を上回らなければプラスになりません。しかし、「つみたて投資」の場合、価格が一時的に下落しても「ある水準」まで戻れば、プラスとなります。値下がり時に買い増すことで平均購入単価が下がるため、その後の上昇で利益が出やすくなるのです。この回復力は、「つみたて投資」の特徴と言えます。
                    <br />
                    価格が下がったら、「量がたくさん買える」とポジティブに考えるのがつみたて投資のコツです。
                  </p>
                  <p className="u-text--center u-mt57px">
                    <img src={image3} alt="「つみたて投資」の効果" />
                  </p>
                  <dl className="p-tumitate__attention__box u-mt20px">
                    <dt className="p-tumitate__attention__head">
                      <span className="p-tumitate__attention__icon">
                        <img src={attention} alt="" />
                      </span>
                      <span className="p-tumitate__attention__title">
                        つみたて効果が期待できない場合も・・・
                      </span>
                    </dt>
                    <dd>
                      {/* eslint-disable-next-line max-len */}
                      価格が一方向に上がるとすれば、安いうちに一括で購入した方が良い結果になります。また、値上がりしたあと元に戻ってしまったら、つみたて投資の場合は、損になってしまいます。つみたての効果が出ない場合もあることには、注意が必要です。
                    </dd>
                  </dl>
                  <p className="c-note u-mt20px">
                    （作成）野村アセットマネジメント
                    <br />
                    {/* eslint-disable-next-line max-len */}
                    ※上記は定額購入の一例であり、実際の値動き等を示すものではありません。口数の計算では小数第2位を切り上げて算出しています。また、計算過程において税金・手数料等は考慮しておりません。実際の算出とは異なります。
                  </p>
                </div>
              </section>
            </div>
            <p className="p-tumitate__lead--secondary u-mt70px">
              月々の積立額や目標金額などから「つみたて」を体験してみましょう
            </p>
            <div className="p-tumitate__button">
              <Link
                to={useDealerCodeUrl('/calc')}
                className="c-button--secondary c-button-arrow--next"
              >
                <span className="c-button__text--m u-mr24px">つみたてシミュレーションはこちら</span>
              </Link>
            </div>
          </div>
        </section>

        <div className="u-bg--white u-mt60px">
          <div className="c-button-group">
            <Link to={useDealerCodeUrl('/')} className="c-button--primary c-button-arrow--back">
              <span className="c-button__text--xs">TOPページへ戻る</span>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </React.Fragment>
  )
}
